export default __webpack_public_path__ + "static/Tip-1-Drink-plenty-of-water-a037874ad90604f5d95a3e5c8a928ffe.jpg";